/**************************************************************************************************/
/*   File: /src/app/shared/components/fileuploader/upload-field/upload-field.component.ts         */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Apr 05 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * The upload field input component
 */
@Component({
  selector: 'nwpl-frnt-upload',
  templateUrl: './upload-field.component.html',
  styleUrls: ['./upload-field.component.scss']
})
export class UploadFieldComponent implements OnInit {
  /**
   * Disable the uploader
   */
  @Input() disabled: boolean;

  /**
    * The accepted file array
    */
  @Input() acceptedTypes: Array<string>;

  /**
   * The file changed emitter
   */
  @Output() changeFilesFromInput: EventEmitter<any> = new EventEmitter<any>();

  /**
   * The constructor
   * @param logger the logger
   */
  constructor(private logger: NGXLogger) { }

  /**
   * The ng on init
   */
  ngOnInit() {
    this.logger.trace('Initialize file upload field component');
  }

  /**
   * The on file changed handler
   * @param files The files list
   */
  onFileChanges(files: FileList) {
    this.logger.trace('The file field has been changed', files);
    this.changeFilesFromInput.emit(files);
  }

}
